import {decorate, observable, action} from 'mobx/lib/mobx';

import StyleStore from "./StyleStore";
import HotelStore from "./HotelStore";
import DisplayStore from './DisplayStore';

class RootStore {

    timerObject = null;

    resetTimer(){
        const timeout = process.env.REACT_APP_TIMEOUTLAYER_TIMEOUT;

        if (this.timerObject){
            clearTimeout(this.timerObject);
        }

        if (this.displayStore.getPopup()) {
            return;
        }

        this.timerObject = setTimeout(() => {
            this.displayStore.setPopup(true);
        }, timeout);
    }

    styleStore = new StyleStore();
    hotelStore = new HotelStore(this);
    displayStore = new DisplayStore(this);

    guidanceCode = '';

    setGuidanceCode(target){
        this.guidanceCode = target.toUpperCase();
    }
}

decorate(RootStore, {
    guidanceCode: observable,
    setGuidanceCode: action
});

export default RootStore;
